var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end mb-2" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "success" },
                    on: { click: _vm.exportToCSV },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "DownloadIcon" },
                    }),
                    _vm._v(" Export to CSV "),
                  ],
                  1
                ),
                _c(
                  "b-button",
                  {
                    staticClass: "ml-2",
                    attrs: { variant: "primary", to: "/product/add" },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "PlusIcon" },
                    }),
                    _vm._v(" Add Product "),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "my-1", attrs: { cols: "12", md: "6" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0", attrs: { label: "Select Columns:" } },
                [
                  _c("b-form-checkbox-group", {
                    attrs: { options: _vm.columnOptions },
                    model: {
                      value: _vm.selectedColumns,
                      callback: function ($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { cols: "12", md: "2", sm: "2" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                attrs: {
                  id: "perPageSelect",
                  size: "sm",
                  options: _vm.pageOptions,
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mb-2",
          staticStyle: { position: "relative", "z-index": "1" },
          attrs: { cols: "12" },
        },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-danger" },
              on: { click: _vm.clearColumnFilters },
            },
            [_vm._v(" Clear Filters ")]
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "",
                  "per-page": _vm.perPage,
                  "current-page": _vm.currentPage,
                  items: _vm.filteredData,
                  fields: _vm.dynamicFields,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                  "sort-direction": _vm.sortDirection,
                },
                on: {
                  "update:sortBy": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  filtered: _vm.onFiltered,
                },
                scopedSlots: _vm._u([
                  {
                    key: "head(name)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Name")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Name",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.filters.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "name", $$v)
                                },
                                expression: "filters.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(barcode)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Barcode")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Code",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.filters.barcode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "barcode", $$v)
                                },
                                expression: "filters.barcode",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(supplierName)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Supplier")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Supplier",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.filters.supplier,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "supplier", $$v)
                                },
                                expression: "filters.supplier",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(categoryName)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Category")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Category",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.filters.category,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "category", $$v)
                                },
                                expression: "filters.category",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(subCategoryName)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Sub Category")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Sub Category",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.filters.subcategory,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "subcategory", $$v)
                                },
                                expression: "filters.subcategory",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "cell(inHouse)",
                    fn: function (data) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(data.item.inHouseManufactured ? "Yes" : "No")
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "head(inHouse)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("In House?")]),
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.inhouseOptions,
                                size: "sm",
                              },
                              on: { change: _vm.filterTable },
                              model: {
                                value: _vm.filters.house,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "house", $$v)
                                },
                                expression: "filters.house",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(type)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Type")]),
                            _c("b-form-select", {
                              attrs: { options: _vm.typeOptions, size: "sm" },
                              on: { change: _vm.filterTable },
                              model: {
                                value: _vm.filters.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "type", $$v)
                                },
                                expression: "filters.type",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "cell(balance)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.focus.v-secondary",
                                modifiers: {
                                  hover: true,
                                  focus: true,
                                  "v-secondary": true,
                                },
                              },
                            ],
                            attrs: {
                              to: _vm.getProductStock(data.item.id),
                              title: "View details of Stock",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-shrink" },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "BoxIcon" },
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(data.item.totalBalance)),
                                ]),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(supplier)",
                    fn: function (data) {
                      return [
                        _vm._v(" " + _vm._s(data.item.supplierName) + " "),
                      ]
                    },
                  },
                  {
                    key: "cell(type)",
                    fn: function (data) {
                      return [
                        data.item.type === 1
                          ? _c("b-badge", { attrs: { variant: "primary" } }, [
                              _vm._v(" Finished Product "),
                            ])
                          : _vm._e(),
                        data.item.type === 2
                          ? _c("b-badge", { attrs: { variant: "info" } }, [
                              _vm._v(" Semi Finished Product "),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-dropdown",
                          {
                            attrs: {
                              variant: "link",
                              "toggle-class": "text-decoration-none",
                              "no-caret": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button-content",
                                  fn: function () {
                                    return [
                                      _c("feather-icon", {
                                        staticClass:
                                          "text-body align-middle mr-25",
                                        attrs: {
                                          icon: "MoreVerticalIcon",
                                          size: "16",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "b-dropdown-item",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.modal-edit",
                                    modifiers: { "modal-edit": true },
                                  },
                                ],
                                attrs: { to: _vm.getProductId(data.item.id) },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "EyeIcon" },
                                }),
                                _c("span", [_vm._v("View")]),
                              ],
                              1
                            ),
                            _c(
                              "b-dropdown-item",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.modal-edit",
                                    modifiers: { "modal-edit": true },
                                  },
                                ],
                                attrs: { to: _vm.getProductEdit(data.item.id) },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "Edit2Icon" },
                                }),
                                _c("span", [_vm._v("Edit")]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center mb-1" },
                [
                  _vm.loading
                    ? _c("b-spinner", {
                        staticStyle: { width: "3rem", height: "3rem" },
                        attrs: {
                          variant: "success",
                          label: "Spinning",
                          block: "",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-pagination", {
                staticClass: "my-0",
                attrs: {
                  "total-rows": _vm.totalRows,
                  "per-page": _vm.perPage,
                  align: "center",
                  size: "sm",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
              _c("b-form-group", [
                _vm._v(
                  " Showing " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? _vm.perPage * (_vm.currentPage - 1) + 1
                        : 0
                    ) +
                    " to " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                        : 0
                    ) +
                    " of " +
                    _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                    " entries "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }